import React from "react";
import { Grid } from "@mui/material";

import InputCheckbox from "../ReadOnlyCheckbox";

const PessoaPoliticamenteExpostaSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    isPoliticamenteExposto,
    isParentePoliticamenteExposto,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={5}>
          <InputCheckbox
            label="Cliente politicamente exposto"
            checked={isPoliticamenteExposto}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <InputCheckbox
            label="Parente politicamente exposto"
            checked={isParentePoliticamenteExposto}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PessoaPoliticamenteExpostaSection;
